// extracted by mini-css-extract-plugin
export var chevronIcon = "_5i-2";
export var teamName = "_5i-1";
export var teamSwitcherButton = "_5i-0";